/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, ember/no-observers, warp-drive/no-legacy-request-patterns */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { isEmpty } from '@ember/utils';
import { service } from '@ember/service';
import DataType from '@linc-technologies/linced-common/enums/data-type';
import { observes } from '@ember-decorators/object';

export default class StripeConnectController extends Controller {
  queryParams = ['state', 'code'];

  // Services
  @service
  options;

  @service
  session;

  @service
  store;

  @tracked
  connected = false;
  @tracked
  connectionInProgress = true;

  @observes('code')
  _triggerConnection() {
    if (!isEmpty(this.state) && !isEmpty(this.code)) {
      this.connect();
    }
  }

  connect() {
    if (this.state !== this.get('session.activeSchool')) {
      // School ID doesn't match.  Don't try to connect.
      this.connected = false;
      this.connectionInProgress = false;
    } else {
      let connection = this.store.createRecord('finance/stripe-connection', {
        schoolId: this.session.school,
        isEnabled: true,
        stripeAuthorizationCode: this.code,
      });

      return connection
        .save()
        .then(() => {
          this.connected = true;
          let optionKey = 'finance:payments:enabled';
          if (!this.options.getValue(optionKey)) {
            // Online Payments option wasn't saved before connecting to Stripe.  Enable it now.
            let school = this.session.get('school');
            let option = school.fields.get(optionKey);
            if (isEmpty(option)) {
              school.addField(optionKey, DataType.BOOLEAN);
              option = school.fields.get(optionKey);
            }
            option.set('value', true);
            return school.save();
          }
        })
        .catch(() => {
          this.connected = false;
        })
        .then(() => {
          this.connectionInProgress = false;
        });
    }
  }
}
